import { AssignmentStatus } from '../types/assignment.types';

export interface Zone {
  zoneId: string;
  zoneName: string;
  timeZone: string;
}


/**
 * Executor information from Microsoft Graph
 */
export interface ExecutorInfo {
  displayName: string;
  email?: string;
  id?: string;
}

/**
 * API response for zones
 */
export interface ZonesResponse {
  zones: Zone[];
}

/**
 * API response for getting assignments
 */
export interface GetAssignmentsResponse {
  executionModels: AssignmentExecution[];
}

/**
 * Request payload for applying an assignment
 */
export interface ApplyAssignmentRequest {
  executionId: string;
  forcefulOverride: boolean;
}

export interface PaginatedAssignmentsRequest {
  pageIndex: number;
  pageSize: number;
  zoneGuid?: string;
}

export interface Timestamp {
  seconds: number | string;
  nanos?: number;
}

export interface AlgorithmicExecutionModel {
  executionId: string;
  executionDate?: Timestamp;
  executorId?: string;
  zoneId?: string;
  executionTargetDate?: Timestamp | string;
  status?: string;
  doWeHaveSweepers?: boolean;
  executionDateFormatted: string;
  assignmentDateFormatted: string;
  hour: string;
  zoneName: string;
  executorName: string;
  [key: string]: unknown;
}

export interface GetPaginatedAlgorithmicExecutionsResponse {
  executions: AlgorithmicExecutionModel[];
  totalItems: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface AssignmentExecution {
  executionId: string;
  executionDate: Timestamp;
  executorId: string;
  zoneId: string;
  executionTargetDate: string;
  status: string;
  doWeHaveSweepers: boolean;
  executorName: string;
}

export interface AssignmentRequest {
  zoneId: string;
  targetDate: Timestamp;
  [key: string]: unknown;
}

export interface AssignmentResponse {
  wasSuccessfull: boolean;
  message?: string;
  [key: string]: unknown;
}
